module.exports = __webpack_public_path__ + "media/images/malharia-6ffb748f856fadb922cdf162515e8831.jpg";